'use strict';

angular.module('ntmApp')
  .directive('timePicker', function () {
      return {
          restrict: 'E',
          templateUrl: 'ng1/src/directives/templates/timePicker.html',
          scope: {
              model: '=',
              disabled: '=',
              required: '=',
              hourStep: '=',
              minuteStep: '=',
              showMeridian: '='
          },
          link: function (scope) {
              scope.data = {};
              scope.data.model = scope.model ? new Date(moment(scope.model).set('second', 0).set('millisecond', 0)) : null;
              scope.minuteStep = scope.minuteStep || 5;
              scope.hourStep = scope.hourStep || 1;
              scope.showMeridian = scope.showMeridian === false ? false : true;
              scope.data.setSecondsToZero = function () {
                  if (scope.data.model) {
                      scope.data.model = new Date(moment(scope.data.model).set('second', 0).set('millisecond', 0));
                      scope.model = scope.data.model;
                  }
              };
          }
      };
  });